import { CSSResultGroup, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './ghs-reusable-grid.css.lit';

@customElement('custom-reusable-grid')
export class ResuableGrid extends LitElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Number, attribute: 'column-number' })
  columnNumber = 1;

  @property({ type: Number, attribute: 'border-style' })
  borderColor = 0;

  render() {
    this.style.setProperty(
      '--border-color',
      this.borderColor === 1 ? '#C7C7C7' : 'transparent'
    );

    return html`
      <div class="grid-container cols-${this.columnNumber}">
        <slot />
      </div>
    `;
  }
}
